import { enableProdMode, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import * as Sentry from '@sentry/angular';
// import { BrowserTracing } from '@sentry/tracing';

import { environment } from './environments/environment';
import { RouteReuseStrategy, Router, provideRouter, PreloadAllModules, withPreloading } from '@angular/router';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { Capacitor } from '@capacitor/core';
import { initializeAuth, indexedDBLocalPersistence } from 'firebase/auth';
import { getApp } from 'firebase/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TitleCasePipe } from '@angular/common';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SafePipe } from './app/pipes/safe.pipe';
import { Logger } from './app/services/logs/logger.service';
import { bootstrapApplication } from '@angular/platform-browser';
import { routes } from './app/app-routing.module';
import { LoggerModule } from 'ngx-logger';
import { AppComponent } from './app/app.component';
// import { defineCustomElements } from '@ionic/pwa-elements/loader';

const packageInfo = require('../package.json');

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentryUrl,
  release: `${packageInfo.version}`,
  // Separate dev/testing events from real users in the Sentry dashboard
  environment: environment.production ? 'production' : 'development',
  tracesSampleRate: 1.0,
  // Replay is disabled unless a sample rate is set; record only sessions that hit an error
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  // v11 collects more by default; don't send IP/auto user info, cookies, or request/response
  // bodies (Firestore payloads contain client data). The user is set explicitly in AuthService.
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpBodies: []
  },
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
});

bootstrapApplication(AppComponent, {
    providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
    { provide: Sentry.TraceService, deps: [Router] },
    provideAppInitializer(() => {
        inject(Sentry.TraceService);
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    importProvidersFrom(IonicModule.forRoot()),
    provideFirebaseApp(() => {
        const app = initializeApp(environment.firebase);
        return app;
    }),
    provideAuth(() => {
        if (Capacitor.isNativePlatform()) {
            console.warn('Capacitor Is Native');
            return initializeAuth(getApp(), {
                persistence: indexedDBLocalPersistence
            });
        }
        else {
            console.warn('Capacitor is not Native');
            return getAuth();
        }
    }),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideFunctions(() => getFunctions(getApp(), 'us-central1')),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(LoggerModule.forRoot(environment.logging)),
    TitleCasePipe,
    InAppBrowser,
    SafePipe,
    Logger
]
})
  .catch(err => console.log(err));

// defineCustomElements(window);
